import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";

export const UsersByRoleChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.numberOfUsersByRole
  );

  const { getDataNumberOfUsersByRole } = useDashboardStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data) {
      getDataNumberOfUsersByRole();
    }
  }, [data, getDataNumberOfUsersByRole]);

  const dataChart = data ? JSON.parse(JSON.stringify(data)) : null;

  return (
    <div className="card shadow border-0 p-4 h-100">
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {dataChart && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="align-items-center mb-0">
              Distribución de usuarios
            </h6>
          </div>
          <Chart
            options={dataChart}
            series={dataChart.series}
            type="pie"
            width="100%"
            height={350}
          />
        </>
      )}
    </div>
  );
};
